import TagSelect from 'components/TagSelect';
import { EMPTY_ARRAY } from 'constants/defaults';
import React from 'react';
import type { Tag } from 'types/tag';
import { Section } from './Section';
import styles from './TagSection.module.scss';

interface TagSectionProps {
  requiredTagIds: Array<number>;
  allowChanges: boolean;
  tags: Array<Tag>;
  allTags: Record<number, Tag>;
  selected: Array<number>;
  onChange: (ids: Array<number>) => void;
  accountId: number;
  disabled: boolean;
  className?: string;
  standalone?: boolean;
  maxHeight?: number;
  defaultTagIds?: Array<number>;
  onOpenChange?: (value: boolean) => void;
  singleTagMode?: boolean;
}

const TagSelectWrap: React.FC<TagSectionProps> = props => {
  const {
    requiredTagIds,
    allowChanges,
    tags,
    allTags,
    selected,
    onChange,
    accountId,
    disabled = false,
    standalone,
    className = '',
    maxHeight,
    defaultTagIds = EMPTY_ARRAY,
    onOpenChange,
    singleTagMode,
  } = props;

  const hasRequiredTags = requiredTagIds.length > 0;

  return (
    <Section noBorder standalone={standalone} className={`${styles.container} ${className}`}>
      <TagSelect
        onOpenChange={onOpenChange}
        disabled={disabled}
        tags={tags}
        allTags={allTags}
        requiredTagIds={requiredTagIds}
        selectedTagIds={selected}
        onChange={onChange}
        accountId={accountId}
        allowChanges={allowChanges}
        maxHeight={maxHeight}
        popoverFixed
        defaultTagIds={defaultTagIds}
        closeOnSelect={!hasRequiredTags}
        closeWhenRequiredTagsAreSelected={hasRequiredTags}
        singleTagMode={!!singleTagMode}
      />
    </Section>
  );
};

export const TagSection = React.memo(TagSelectWrap);
